export const seo = {
  siteUrl: 'https://jamesgodfreyeric.com/',
  siteName: 'Jim Godfrey',
  title: 'Jim Godfrey | Executive & Board Leadership',
  description:
    'Jim Godfrey — executive and board leader with extensive leadership experience, board experience, and a distinguished professional career.',
  image: 'https://cdn.magicpatterns.com/uploads/sQ9o15GURKuisDzW2miu3X/Godfrey_IPY_UN_Oct_2007.jpg',
  imageAlt: 'Jim Godfrey speaking as Chairman of the International Potato Center',
  themeColor: '#0B1522',
  locale: 'en_GB',
};
